/**
 * filter for marketing groups, will replace the word with that specified from the marketing group
 */
angular.module('bookingApp').filter('marketingGroup', function () {
    return function (input, type, marketingGroup) {
        if (!marketingGroup) {
            return input;
        }
        if (marketingGroup.deleted) {
            return input;
        }
        var replacementLabel = input;
        switch (type) {
            case 'single':
                replacementLabel = marketingGroup.labelSingle;
                break;
            case 'plural':
                replacementLabel = marketingGroup.labelPlural;
                break;
            case 'singleShort':
                replacementLabel = marketingGroup.labelSingleShort;
                break;
            case 'pluralShort':
                replacementLabel = marketingGroup.labelPluralShort;
                break;
        }
        return replacementLabel;
    };
});